'use strict'

const wixDataFunctions = ['save', 'remove', 'find', 'filter']
const wixDataSchemasFunctions = ['list']

const wrapWixDataFunctions = (wixData, functions, errorWrapper) =>
  functions.reduce((proxy, f) => {
    proxy[f] = errorWrapper((...args) => wixData[f](...args))
    return proxy
  }, {})

module.exports = (wixDataCodeZone, wixDataCreator) => {
  const {wixData, wixDataSchemas} = wixDataCreator()

  return {
    wixDataProxy: wrapWixDataFunctions(wixData, wixDataFunctions, wixDataCodeZone),
    wixDataSchemasProxy: wrapWixDataFunctions(wixDataSchemas, wixDataSchemasFunctions, wixDataCodeZone)
  }
}



// WEBPACK FOOTER //
// ./wix-data/wixDataProxy.js